import JWT from "@/utils/jwt"
import router from "@/router";
import { login, mobilefone, info, register, refreshToken, forgotPassword, resetPassword } from './api'
import { SET_ACCESS_TOKEN, SET_AUTH, PURGE_AUTH, SET_ERROR, SET_LOADING, SET_STATUS, CLEAR_DATA } from "./constants";

const authRegister = async ({ commit }, user) => {
  commit(SET_LOADING, true);
  await register(user)
    .then(( response ) => {
      commit(SET_LOADING, false);

      if (response.data.access_token) {
        commit(SET_ACCESS_TOKEN, response.data);
        
        if (user.nextUrl.length > 0) {
          window.location.href = user.nextUrl
        } else {
          router.go({ name: 'home' })
        }
      } else {
        const errors = response.data

        for (var item in errors) {
          commit(SET_ERROR, errors[item].shift())
        }
      }
    })
    .catch(err => {
      commit(SET_LOADING, false);
      if (err.response.data.error) {
        commit(SET_ERROR, err.response.data.error)
      } else if(err.response.data.message) {
        commit(SET_ERROR, err.response.data.message)
      } else {
        commit(SET_ERROR, err.response.data)
      }
    });
};

const authLogin = async ({ commit }, { email, password, nextUrl }) => {
  commit(SET_LOADING, true);
  await login(email, password)
    .then(( response ) => {
      commit(SET_LOADING, false);
      commit(SET_ACCESS_TOKEN, response.data );
      
      if (nextUrl.length > 0) {
        window.location.href = nextUrl
      } else {
        router.go({ name: 'home' })
      }
    })
    .catch(err => {
      commit(SET_LOADING, false);

      if (err.response.data.error) {
        commit(SET_ERROR, err.response.data.error)
      } else {
        commit(SET_ERROR, err.response.data.message)
      }
    });
};

const authMobiedu = async ({ commit }, { phone, password }) => {
  commit(SET_LOADING, true);
  await mobilefone(phone, password)
    .then(( response ) => {
      commit(SET_LOADING, false);
      commit(SET_ACCESS_TOKEN, response.data );
      
      router.go({ name: 'home' })
    })
    .catch(err => {
      commit(SET_LOADING, false);

      if (err.response.data.error) {
        commit(SET_ERROR, err.response.data.error)
      } else {
        commit(SET_ERROR, err.response.data.message)
      }
    });
};

const authToken = async ({ commit }) => {
  let refreshToken = JWT.getRefreshToken()
  if (refreshToken) {
    await refreshToken({
      token: refreshToken
    })
      .then((res) => {
        commit(SET_ACCESS_TOKEN, res.data)
      })
      .catch((res) => {
        commit(SET_ERROR, res.data)
      })
  }
}

const authLogout = async ({ commit }) => {
  commit(PURGE_AUTH);
  JWT.destroyToken();
  router.push("/");
};

const authForgotPassword = async ({ commit }, { email }) => {
  commit(SET_LOADING, true);
  forgotPassword(email)
    .then(( ) => {
      commit(SET_LOADING, false);
      const status = { page: 'ForgotPassword', isDone: true }
      commit(SET_STATUS, status);
    })
    .catch(({ response }) => {
      commit(SET_LOADING, false);
      commit(SET_ERROR, response.data.errors);
    });
};

const authResetPassword = async ({ commit }, { email, password, verify_code }) => {
  commit(SET_LOADING, true);
  await resetPassword(email, password, verify_code)
    .then(( ) => {
      commit(SET_LOADING, false);
      const status = { page: 'ResetPassword', isDone: true }
      commit(SET_STATUS, status);
    })
    .catch(({ response }) => {
      commit(SET_LOADING, false);
      commit(SET_ERROR, response.data.errors);
    });
};

const authInfo = async ({ commit }) => {
  if (JWT.getAccessToken()) {
    await info()
    .then(( res ) => {
      commit(SET_AUTH, res.data)
    })
    .catch(({ res }) => {
      commit(SET_ERROR, res.data)
    })
  } else {
    if (JWT.getRefreshToken()) {
      await refreshToken({
        token: `${JWT.getRefreshToken()}`
      })
        .then(( resToken ) => {
          commit(SET_LOADING, false)
          commit(SET_ACCESS_TOKEN, resToken.data)
        })
        .catch(err => {
          commit(PURGE_AUTH)
          commit(SET_LOADING, false)
          commit(SET_ERROR, err.response.data)
        })
    } else {
      commit(PURGE_AUTH)
    }
  }
};

const setLoading = ({ commit }, value) => {
  commit(SET_LOADING, value);
};

const setStatus = ({ commit }, value) => {
  commit(SET_STATUS, value);
};

const clearData = ({ commit }) => {
  commit(CLEAR_DATA);
};

export default {
  authToken,
  authLogin,
  authMobiedu,
  authLogout,
  authRegister,
  authForgotPassword,
  authResetPassword,
  authInfo,
  setLoading,
  setStatus,
  clearData
};
